import React from "react";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

import Background from "../shared/Background";
import ModalWrapper from "../shared/ModalWrapper";
import CloseIcon from "../shared/CloseIcon";
export default function Modal({ children }) {
  const navigate = useNavigate();

  const onDismiss = () => {
    navigate("/videos", { replace: true });
  };

  return (
    <Background onClick={onDismiss}>
      <ModalWrapper>
        <CloseIcon onClick={onDismiss}></CloseIcon>
        {children}
      </ModalWrapper>
    </Background>
  );
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
};
